import { Table, Button, Space, Card } from 'antd'
import { PlusOutlined } from "@ant-design/icons";
import AuthComponent from "../../../components/AuthComponent";

const TableComponent = (props) => {
  const {
    columns = [],
    btnName,
    page = {},
    total = 0,
    loading = false,
    list = [],
    addRecommend = () => { },
    changePage = () => { },
    authKey = { search: "", export: "" },
    rowSelection = false
  } = props

  return (
    <>
      <Space style={{ display: "flex", background: "#ffffff", padding: "15px" }}>
        <AuthComponent authKey={authKey.search}>
          <Button
            type="primary"
            onClick={addRecommend}
            icon={<PlusOutlined />}
          >{btnName}</Button>
        </AuthComponent>
      </Space>
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={list}
        loading={loading}
        rowKey={(record => record.id)}
        pagination={{
          pageSize: page.pageSize,
          current: page.pageIndex,
          total,
          showTotal: (total) => `当前条件共检索到 ${total} 条信息`,
          onChange: (pageIndex, pageSize) => changePage({ pageIndex, pageSize }),
        }}
      />
    </>
  )
}

export default TableComponent